import { create } from "zustand";
export const useLoansStore = create((set) => ({
  loans: null,
  loansCompanyDetail: null,
  loan: null,
  loanVendors: null,
  loanVendorProducts: {},
  loanVendorProductAvailability: {},
  clearLoans: () =>
    set({
      loans: null,
      loan: null,
      loanVendors: null,
      loanVendorProducts: {},
      loanVendorProductAvailability: {},
    }),
  setLoans: (loans) => set({ loans }),
  setLoansCompanyDetail: (loansCompanyDetail) => set({ loansCompanyDetail }),
  setLoan: (loan) => set({ loan }),
  setLoanVendors: (loanVendors) => set({ loanVendors }),
  setLoanVendorProducts: (loanVendorProducts) => set({ loanVendorProducts }),
  setLoanVendorProductAvailability: (loanVendorProductAvailability) =>
    set({ loanVendorProductAvailability }),
}));
